import React, { useCallback, useEffect, useRef, useState } from 'react';
import { observer } from 'mobx-react-lite';

import { useStore } from '../../../hooks';

import LoaderVideo from '../../../assets/media/loader/ichancy-loader.mp4';

interface IChancyLoaderProps {

}

export const IChancyLoader: React.FC<IChancyLoaderProps> = observer(() => {

  const { loaderStore } = useStore();
  const { gameLoadedTrigger } = loaderStore;

  const videoRef = useRef<HTMLVideoElement>(null);

  const [videoEnded, setVideoEnded] = useState(false);

  const [progress, setProgress] = useState(0);

  useEffect(() => {
    const raf = requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        setProgress(60);
      });
    });
    return () => cancelAnimationFrame(raf);
  }, []);

  useEffect(() => {
    if (videoEnded && gameLoadedTrigger) {
      const t1 = setTimeout(() => setProgress(100), 500);
      const t2 = setTimeout(() => loaderStore.setGameLoaded(true), 1000);
      return () => {
        clearTimeout(t1);
        clearTimeout(t2);
      };
    }
  }, [videoEnded, gameLoadedTrigger]);

  useEffect(() => {
    autoplayVideo();
  }, []);

  const autoplayVideo = useCallback(async () => {
    const video = videoRef.current;
    if (!video) return;
    try {
      // Attempt to play the video
      await video.play();
      // If the play() promise resolves, it means autoplay is working, 
      // and therefore, Low Power Mode is likely OFF.
      video.addEventListener('ended', () => {
        setVideoEnded(true);
      }, false);
    } catch (error) {
      setVideoEnded(true);
    }
  }, []);

  return (
    <div className="global-loader-wrapper ichancy-loader" id="loader">
      <div className="ichancy-loader-container">
        <video
          muted
          playsInline
          ref={videoRef}
          className="loader-video"
        >
          <source
            type="video/mp4"
            src={LoaderVideo}
          />
        </video>
        <div className={`ichancy-loader-overlay show`}>
          <div className="ichancy-loader-progress">
            <div className="ichancy-loader-progress-bar" style={{ width: `${progress}%` }}>
              <span className="icon-storm ichancy-loader-bolt" />
            </div>
          </div>
          <p className="ichancy-loader-text">Loading...</p>
        </div>
      </div>
    </div>
  );
});
